export const DELIVERY_OPTIONS_TEST_ID = 'DeliveryOptions';
export const SAFE_DROP_OPTIONS_ROW_TEST_ID = 'SafeDropOptionsRow';
export const REDIRECT_OPTIONS_ROW_TEST_ID = 'RedirectOptionsRow';
export const LOADING_ROW_TEST_ID = 'LoadingRow';
